module.exports = __webpack_public_path__ + "img/blog3.77349065.jpg";